
export default {
  title: 'Billing',
  button_save: 'Save',
}